import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
type Props = {
  char: string;
  size?: 'sm' | 'lg';
  tone?: 'dark' | 'light';
};
const SIZES = {
  sm: 'h-[24px] w-[17px] text-[12px] sm:h-[34px] sm:w-[24px] sm:text-[16px] md:h-[40px] md:w-[28px] md:text-[19px]',
  lg: 'h-[48px] w-[34px] text-[26px] md:h-[54px] md:w-[38px] md:text-[30px] xl:h-[62px] xl:w-[44px] xl:text-[34px]'
};
const TONES = {
  dark: {
    tile: 'bg-[#0c1628] text-cream',
    hinge: 'bg-black/60',
    sheen: 'bg-white/[0.03]'
  },
  light: {
    tile: 'bg-[#f1f3f6] text-ink',
    hinge: 'bg-white',
    sheen: 'bg-white/40'
  }
};

/** One tile of a split-flap departure board; flips when its character changes. */
export function SplitFlapChar({
  char,
  size = 'sm',
  tone = 'dark'
}: Props) {
  const reduce = useReducedMotion();
  const display = char === ' ' ? '\u00A0' : char;
  const t = TONES[tone];
  return <span className={`relative inline-flex items-center justify-center overflow-hidden rounded-[2px] font-accent leading-none [perspective:200px] ${t.tile} ${SIZES[size]}`} data-id="element-420" data-mp="12tagzaehjvfz">
      <AnimatePresence initial={false} mode="popLayout" data-id="element-421" data-mp="1seu1d00n1wu9">
        <motion.span key={char} initial={reduce ? {
        opacity: 0
      } : {
        rotateX: -90,
        opacity: 0.4
      }} animate={reduce ? {
        opacity: 1
      } : {
        rotateX: 0,
        opacity: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        rotateX: 90,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="block [transform-origin:50%_50%]" data-id="element-422" data-mp="1seagbafoysc0">
          {display}
        </motion.span>
      </AnimatePresence>
      {/* Hinge line across the middle of the flap */}
      <span aria-hidden="true" className={`pointer-events-none absolute inset-x-0 top-1/2 h-px -translate-y-1/2 ${t.hinge}`} data-id="element-423" data-mp="1ofbg234wnjqw" />
      <span aria-hidden="true" className={`pointer-events-none absolute inset-x-0 top-0 h-1/2 ${t.sheen}`} data-id="element-424" data-mp="vwo175gi50y9" />
    </span>;
}